import { render, staticRenderFns } from "./PatchNotes.vue?vue&type=template&id=f39ac35e&scoped=true&"
import script from "./PatchNotes.vue?vue&type=script&lang=js&"
export * from "./PatchNotes.vue?vue&type=script&lang=js&"
import style0 from "./PatchNotes.vue?vue&type=style&index=0&id=f39ac35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39ac35e",
  null
  
)

export default component.exports